// src/utils/index.js
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const createPageUrl = (pageName) => {
  return `/${pageName.toLowerCase()}`
}

export const formatDate = (date) => {
  if (!date) return '-'
  return new Intl.DateTimeFormat('it-IT', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(date))
}